import { Provider, InjectionToken } from '@angular/core';
import { MasterStateService } from './master-state.service';

/**
 * Configuration for the MasterStateService.
 * @param entityTable`` The name of the table in Dexie DB.
 * @param endPointQuery The API endpoint for querying data.
 */
export interface MasterStateConfig {
  pathTable: string; // name of path for the knowledge (category) but also this name is used as table name in dexie db
  sourceCoreEndPoint: string; // api endPointQuery: string; // api endpoint for querying data
  userStateEndPoint: string; // api endPointQuery: string; // api endpoint for querying data
}

export function provideMasterState<T>(token: InjectionToken<MasterStateService<T>>, config: MasterStateConfig): Provider {
  return {
    provide: token,
    useFactory: () => new MasterStateService<T>(config),
  };
}
